module.exports = __webpack_public_path__ + "static/img/119.adb228b6.png";